// extracted by mini-css-extract-plugin
export default {"pageButton":"PageSelector_pageButton__aDQPi"};